// Custom Dropdown Initialization - Optimized for Quick View Only
class DropdownManager {
  static initializeAllDropdowns(container = document) {
    // Only initialize dropdowns, the main page has its own handlers
    this.initializeProductDescriptionDropdowns(container);
    this.initializeCustomAccordions(container);
  }

  static initializeProductDescriptionDropdowns(container = document) {
    const dropdowns = container.querySelectorAll('.product-description-dropdown');
    
    dropdowns.forEach(dropdown => {
      const toggle = dropdown.querySelector('.dropdown-toggle');
      const content = dropdown.querySelector('.dropdown-content');
      
      if (toggle && content && !toggle.hasAttribute('data-dropdown-initialized')) {
        // Reset state and mark as initialized
        content.classList.remove('open');
        toggle.classList.remove('active');
        toggle.setAttribute('data-dropdown-initialized', 'true');
        
        // Remove existing listeners without cloning
        toggle.removeEventListener('click', this.handleDropdownClick);
        
        toggle.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          
          const isOpen = content.classList.contains('open');
          content.classList.toggle('open', !isOpen);
          toggle.classList.toggle('active', !isOpen);
        });
      }
    });
  }

  static initializeCustomAccordions(container = document) {
    const accordions = container.querySelectorAll('.custom-accordion-wrapper');
    
    accordions.forEach(accordion => {
      const toggle = accordion.querySelector('.custom-accordion-toggle');
      const content = accordion.querySelector('.custom-accordion-content');
      
      if (toggle && content && !toggle.hasAttribute('data-accordion-initialized')) {
        // Reset state and mark as initialized
        content.classList.remove('open');
        toggle.classList.remove('active');
        toggle.setAttribute('data-accordion-initialized', 'true');
        
        // Remove existing listeners without cloning
        toggle.removeEventListener('click', this.handleAccordionClick);
        
        toggle.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          
          const isOpen = content.classList.contains('open');
          content.classList.toggle('open', !isOpen);
          toggle.classList.toggle('active', !isOpen);
        });
      }
    });
  }

  static initializeDetailsDisclosures(container = document) {
    // Skip details initialization for now to avoid conflicts
    // The existing details-disclosure.js handles this
    return;
  }
}

window.DropdownManager = DropdownManager;